import { render, staticRenderFns } from "./balanceUser.vue?vue&type=template&id=0e31934c&scoped=true"
import script from "./balanceUser.vue?vue&type=script&lang=js"
export * from "./balanceUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e31934c",
  null
  
)

export default component.exports